import requestManager from '../lib/requestManager';

class BaseAdapter {
  /**
   * Generates request headers for authenticated routes.
   *  Appends the csrf token in the header, required by protected Rails routes
   *
   * @return {Object} request headers
   */
  static requestHeaders() {
    return ({
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        'Accept': 'application/json'
      }
    });
  }

  /**
   * Make a GET request
   *
   * @param {string} [endpoint] - the API endpoint to use
   * @param {object} [params] - params to be sent
   * @return {Promise} a Promise that will resolve into an object or reject with
   *                   an error object for its reason
   */
  getRequest(endpoint, params) {
    return requestManager('GET', endpoint, params);
  }

  /**
   * Make a POST request
   *
   * @param {string} [endpoint] - the API endpoint to use
   * @param {object} [data] - data to be sent
   * @return {Promise} a Promise that will resolve into an object or reject with
   *                   an error object for its reason
   */
  postRequest(endpoint, data) {
    let requestParams = {
      ...this.constructor.requestHeaders(),
      data: data
    };

    return requestManager('POST', endpoint, requestParams);
  }

  /**
   * Make a PATCH request
   *
   * @param {string} [endpoint] - the API endpoint to use
   * @param {object} [data] - data to be sent
   * @return {Promise} a Promise that will resolve into an object or reject with
   *                   an error object for its reason
   */
  patchRequest(endpoint, data) {
    let requestParams = {
      ...this.constructor.requestHeaders(),
      data: data
    };

    return requestManager('PATCH', endpoint, requestParams);
  }

  /**
   * Make a DELETE request
   *
   * @param {string} [endpoint] - the API endpoint to use
   * @return {Promise} a Promise that will resolve into an object or reject with
   *                   an error object for its reason
   */
  deleteRequest(endpoint) {
    return requestManager('DELETE', endpoint, this.constructor.requestHeaders());
  }
}

export default BaseAdapter;



// WEBPACK FOOTER //
// ./app/assets/javascripts/adapters/base.js